import { Component, inject } from '@angular/core';
import { FormBuilder, FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { PaTextareaComponent } from 'src/app/shared/ui-kit/pa-textarea/pa-textarea.component';

@Component({
  selector: 'app-textarea-view',
  templateUrl: './textarea-view.component.html',
  styleUrls: ['./textarea-view.component.scss'],
  standalone: true,
  imports: [PaTextareaComponent, FormsModule, ReactiveFormsModule],
})
export class TextareaViewComponent {
  private fb = inject(FormBuilder);

  form = this.fb.group({
    counter: new FormControl('', [Validators.required, Validators.minLength(10)]),
    counter2: new FormControl('string\nstring\nstring3\nstring\nstring\nstring4\nstring\nstring'),
  });

  form2 = this.fb.group({
    counter: new FormControl('', [Validators.required, Validators.maxLength(10)]),
  });

  textareaErrorMessages = {
    required: 'Описание обязательно для заполнения.',
    maxlength: (error: { requiredLength?: number; actualLength?: number }) =>
      `Максимальная длина описания: ${error.requiredLength} символов (сейчас: ${error.actualLength}).`,
  };
}
